import { api } from './api';
import { getValue } from '../cache';

export async function fetchClub(clubId) {
  const key = 'clubs-' + clubId
  const cacheTTL = 600000

  const value = await getValue(key, async function() {
    const apiInst = await api();
    const response = await apiInst.get('clubs/' + clubId + '?include=logo_image');
    return response.data;
  }, cacheTTL)

  return value


}
